import { ElementRef, OnChanges } from '@angular/core';
import { Directive } from '@angular/core';

@Directive({
    selector: '[stepperFix]',
    standalone: false
})
export class StepperFixDirective {

 
  constructor(el: ElementRef) { 
    if(this.checkPlatform()){
      el.nativeElement.classList.add('stepper-bottom-margin');
    }
  }

  private checkPlatform(){
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform);
  }


}
